module.exports = __webpack_public_path__ + "img/subtract.42dbef08.png";